



















































































































































































































import { default as Component } from 'vue-class-component';

import ReviewWidget from '@/components/widgets/ReviewWidget.vue';

import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';

import Format from '@/interfaces/Format';

const formatProvider = IocContainer.get<Format>(SERVICES.FORMAT);

@Component({
  props: {
    data: Object,
    isMobile: Boolean
  },
  filters: {
    iban: formatProvider.iban(),
    date: formatProvider.date(),
    zip: formatProvider.zip()
  }
})
export default class ElliCongratulationsWidget extends ReviewWidget {
  public mounted(): void {
    // Remove token
    //localStorage.removeItem(process.env.VUE_APP_SESSION_STORAGE_KEY);

    document.location.href = document.location.href + '#success';
  }

  get genericStorage(): any {
    return this.dataReview.genericStorage ?? {};
  }

  public printOverview(): boolean {
    window.print();
    return true;
  }
}
